import { Modal, RecordProfile } from "dyl-components"
import { useEffect, useState } from "react"
import contactActions from "actions/contact"
import accountsActions from "actions/account"
import { useDispatch, useSelector } from "react-redux"
import { Segment } from "semantic-ui-react"
import ProfileDetails from "pages/ContactProfile/ProfileDetails"
import QuoteBuilderProvider from "shared/context/QuoteBuilderProvider"
import { ProfileHeader } from "pages/ContactProfile/ProfileHeader"
import groupsActions from "actions/groups";
import onReadContactInformationDispatch from "shared/onReadContactInfoDispatch"
import { AccountDetails } from "pages/Account/AccountDetails"
import { ProfileHeader as ProfileDetailsAccount } from "pages/Account/ProfileHeader"
import contactPhoneActions from 'actions/contact_phone';
import contactEmailActions from 'actions/contact_email';

const ArchivedReportsViewModal = ({ open, onClose, contact_id, account_id }) => {
    const dispatch = useDispatch()
    const { contact, isReadingContact, contactsInHotlist, account, isReadingAccount } = useSelector((state) => ({
        contact: state.contact.contact,
        isReadingContact:
            state.contact.isReadingContact ||
            state.contact_email.isReadingEmails,
        contactsInHotlist: state.groups.contactsInHotlist,
        account: state.account.account,
        isReadingAccount: state.account.isReadingAccount || state.account.isReadingContactIds || state.contact_email.isReadingEmails
    }))

    const [isInHotlist, setIsInHotlist] = useState(false);

    useEffect(() => {
        if (contact_id) {
            (onReadContactInformationDispatch(dispatch))(contact_id);
            dispatch(groupsActions.readContactGroups(contact_id));

            dispatch(groupsActions.checkHotlist({ contacts: [contact_id] }));
        } else if (account_id) {
            dispatch(accountsActions.readAccount(account_id))
            dispatch(accountsActions.readContactIds(account_id));
            dispatch(contactPhoneActions.getContactPhones(account_id));
            dispatch(contactEmailActions.getContactEmails(account_id));
        }
    }, [contact_id, account_id, dispatch])
    useEffect(() => {
        setIsInHotlist(contactsInHotlist.includes(Number(contact_id)));
    }, [contactsInHotlist, contact_id])
    return (
        <Modal open={open} onClose={onClose} {...(account_id ? { size: "large" } : {})}>
            <Modal.Header>
                View Archived Record
            </Modal.Header>
            <Segment loading={isReadingContact || isReadingAccount} basic>
                <Modal.Content scrolling >
                    <QuoteBuilderProvider refreshAccountInformation={() => {
                        return dispatch(contactActions.readContact(contact_id));
                    }}>

                        {(contact_id ? contact?.id : account?.id) && <RecordProfile
                            isDetailsSectionOpen={true}
                            header={
                                contact_id ? <ProfileHeader
                                    id={Number(contact_id)}
                                    name={contact?.first_name + ' ' + contact?.last_name}
                                    isInHotlist={isInHotlist}
                                    onHotlistToggle={() => { }}
                                    isSidePanelOpen={false}
                                /> : <ProfileDetailsAccount
                                    name={account.name}
                                    id={account_id}
                                    type='Account'
                                    isSidePanelOpen={false}
                                />
                            }
                            details={contact_id ? <ProfileDetails contactId={contact_id} /> : <AccountDetails
                                onPin={() => { }}
                                onReplacePinnedContact={() => { }}
                                onUnpin={() => { }}

                                onSetPrimary={() => { }}
                                isSidePanelOpen={false}
                                account_type={account?.account_type || ''}
                                accountId={account_id}
                            />}
                            onToggleSidePanel={() => {
                            }}
                            isSidePanelOpen={false}
                        />}
                    </QuoteBuilderProvider>
                </Modal.Content>
            </Segment>
        </Modal>
    )
}

export default ArchivedReportsViewModal
